import { Component, HostListener } from '@angular/core';
import { environment } from 'src/environments/environment.development';
import { RolesService } from '../setup/roles/roles.service';
import { DataService } from 'src/app/helpers/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modules-wrapper',
  templateUrl: './modules-wrapper.component.html',
  styleUrls: ['./modules-wrapper.component.scss']
})
export class ModulesWrapperComponent {
  menuOpen = false;
  showPlusButton = false;
  showChatButton = false;
  userRights: string[] = [];
  roleId = "";
  employeeData = "";
  userRole? = "";
  hover = false;
  windowScrolled = false;
  topOffset = 150;

  readonly requiredRights = ["H1026", "I1015", "A1023", "F1007", "B"];

  leadURL = `${environment.leadKonnekt_url}/app/all-leads`;
  inventoryURL = `${environment.inventory_url}/select-product`;

  constructor(
    private _rolesServ: RolesService,
    private _dataServ: DataService,
    private router: Router
  ) { }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    this.windowScrolled = scrollPosition > this.topOffset;
  }

  ngOnInit() {
    this.roleId = this._dataServ.employeeValue?.empRoleId;
    this.employeeData = this._dataServ.employeeValue;
    this.userRole = this._dataServ.userValue?.role;

    if ((this.userRole ?? '').trim().toLowerCase() !== 'customer') {
      this._rolesServ.getCodesByEmpRoleId(this.roleId)
        .subscribe((rights: string[]) => {
          this.userRights = rights;

          // SHOW + BUTTON IF USER HAS ANY REQUIRED RIGHT
          this.showPlusButton = this.requiredRights.some(r =>
            this.userRights.includes(r)
          );

          this.showChatButton = this.userRights.includes('B');
        });
    }
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  navigateTo(url: string) {
    if (url.startsWith('http')) {
      window.location.href = url;
    } else {
      this.router.navigateByUrl(url);
    }
  }

  get itemsBottomPosition() {
    return this.windowScrolled ? '10rem' : '6rem';
  }
}
